// topbar.js — Shared helpers for the Shopify theme
// Provides: floating nav button, floating cart button, scroll listeners,
// and subnav burger injection. The main nav is rendered by header.liquid.

(function(){

  // ── FLOATING NAV (hamburger pill that opens the drawer on scroll) ──────────
  function buildFloatingNav(){
    if (document.getElementById('oba-fab-nav')) return;
    var btn = document.createElement('button');
    btn.id = 'oba-fab-nav';
    btn.className = 'oba-fab-nav';
    btn.type = 'button';
    btn.setAttribute('aria-label','Open menu');
    btn.innerHTML = '<span></span><span></span><span></span>';
    document.body.appendChild(btn);
    btn.addEventListener('click', function(){ window.OBADrawer && OBADrawer.open(); });

    var ticking = false;
    function update(){
      ticking = false;
      var y = window.scrollY || window.pageYOffset || 0;
      if (y > 120) btn.classList.add('on');
      else btn.classList.remove('on');
    }
    window.addEventListener('scroll',function(){
      if(!ticking){ requestAnimationFrame(update); ticking = true; }
    },{passive:true});
    update();
  }

  // ── FLOATING CART (visible after scroll on every page except checkout) ─────
  function buildFloatingCart(){
    if (document.getElementById('oba-fab-cart')) return;
    var btn = document.createElement('button');
    btn.id = 'oba-fab-cart';
    btn.className = 'oba-fab-cart';
    btn.type = 'button';
    btn.setAttribute('aria-label','Open bag');
    btn.innerHTML =
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6">'+
        '<path d="M5 7h14l-1.5 11a2 2 0 01-2 1.7H8.5A2 2 0 016.5 18L5 7z"/>'+
        '<path d="M9 7V5a3 3 0 016 0v2"/>'+
      '</svg>'+
      '<span class="oba-fab-badge" data-cart-badge>0</span>';
    document.body.appendChild(btn);
    btn.addEventListener('click',function(){ if(window.OBA) OBA.openCart(); });

    var ticking = false;
    function update(){
      ticking = false;
      var y = window.scrollY || window.pageYOffset || 0;
      if (y > 280) btn.classList.add('on');
      else btn.classList.remove('on');
    }
    window.addEventListener('scroll',function(){
      if (!ticking){ requestAnimationFrame(update); ticking = true; }
    },{passive:true});
    update();
    if (window.OBA) OBA.updateBadge();
  }

  function init(){
    // Build floating buttons (all pages)
    buildFloatingCart();
    buildFloatingNav();

    // Inject burger into subnav (for collection pages etc.) if it exists
    var subActs = document.querySelector('.subnav .subnav-actions, .subnav [data-subnav-actions]');
    if (subActs && !document.getElementById('sn-burger')){
      var b = document.createElement('button');
      b.id = 'sn-burger';
      b.className = 'oba-burger oba-burger-sub';
      b.setAttribute('aria-label','Menu');
      b.type = 'button';
      b.innerHTML = '<span></span><span></span><span></span>';
      subActs.insertBefore(b, subActs.firstChild);
      b.addEventListener('click',function(){window.OBADrawer && OBADrawer.open();});
    }

    // Initial badge sync
    if (window.OBA) OBA.updateBadge();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
